<template>
  <!--begin::Menu wrapper-->
  <div
    id="kt_aside_menu_wrapper"
    ref="scrollElRef"
    class="hover-scroll-overlay-y my-5 my-lg-5"
    data-kt-scroll="true"
    data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
    data-kt-scroll-height="auto"
    data-kt-scroll-offset="0"
    data-kt-scroll-wrappers="#kt_aside_menu"
  >
    <!--begin::Menu-->
    <div
      id="#kt_header_menu"
      class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
      data-kt-menu="true"
    >
      <!-- ADMINISTRACIÓN -->
      <div v-if="rol === 'admin' || rol === 'editor'">
        <div class="menu-item">
          <div class="menu-content pt-8 pb-2">
            <span class="menu-section text-muted text-uppercase fs-8 ls-1">
              ADMINISTRACIÓN
            </span>
          </div>
        </div>
        <!-- USUARIOS -->
        <div class="menu-item">
          <router-link class="menu-link" active-class="active" to="/listUser">
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-user"></i>
              </span>
            </span>
            <span class="menu-title">Usuarios</span>
          </router-link>
        </div>
        <!-- CENTROS PENITENCIARIOS -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/listPenitentiary"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-house"></i>
              </span>
            </span>
            <span class="menu-title">Centros Penitenciarios</span>
          </router-link>
        </div>
        <!-- BUSQUEDA PPL -->
        <!-- <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            @click="openModalSearch"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-search"></i>
              </span>
            </span>
            <span class="menu-title">Búsqueda PPL </span>
          </router-link>
        </div> -->
      </div>
      <div v-if="rol !== 'visitas'">
      <!-- PRIVADOS DE LIBERTAD -->
      <div class="menu-item">
        <div class="menu-content pt-8 pb-2">
          <span class="menu-section text-muted text-uppercase fs-8 ls-1">
            PRIVADOS DE LIBERTAD
          </span>
        </div>
      </div>
      <!-- FILIACIÓN -->
      <div class="menu-item">
        <router-link
          v-if="
            rol !== 'consultas nacional' && rol !== 'consultas departamentales'
          "
          class="menu-link"
          active-class="active"
          to="/courtOrderList"
        >
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
            <i class="fas fa-pencil"></i>
            </span>
          </span>
          <span class="menu-title">Filiación</span>
        </router-link>
      </div>
      <!-- LISTAS -->
      <div
        class="menu-item menu-accordion"
        data-kt-menu-sub="accordion"
        data-kt-menu-trigger="click"
      >
        <span class="menu-link">
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
              <i class="fas fa-list"></i>
            </span>
          </span>
          <span class="menu-title">Listas</span>
          <span class="menu-arrow"></span>
        </span>
        <div class="menu-sub menu-sub-accordion">
          <!-- LISTA GENERAL -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/listDeprivedLibertybyPrisons"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">General</span>
            </router-link>
          </div>
          <!-- LISTA SENTENCIADOS -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/listDeprivedLibertySentence"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Sentenciados</span>
            </router-link>
          </div>
          <!-- LISTA PREVENTIVOS -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/listDeprivedLibertyPrevent"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Preventivos</span>
            </router-link>
          </div>
          <!-- LISTA APREMIO -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/listDeprivedLibertyApremio"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Apremio</span>
            </router-link>
          </div>
          <!-- <div
            v-if="item2.sectionTitle"
            :class="{ show: hasActiveChildren(item2.route) }"
            class="menu-item menu-accordion"
            data-kt-menu-sub="accordion"
            data-kt-menu-trigger="click"
          >
            <span class="menu-link">
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">{{
                translate(item2.sectionTitle)
              }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              :class="{ show: hasActiveChildren(item2.route) }"
              class="menu-sub menu-sub-accordion"
            >
              <template v-for="(item3, k) in item2.sub" :key="k">
                <div v-if="item3.heading" class="menu-item">
                  <router-link
                    class="menu-link"
                    active-class="active"
                    :to="item3.route"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      translate(item3.heading)
                    }}</span>
                  </router-link>
                </div>
              </template>
            </div>
          </div> -->
        </div>
      </div>
      <!-- TRASLADOS Y SALIDAS  -->
      <div class="menu-item">
        <div class="menu-content pt-8 pb-2">
          <span class="menu-section text-muted text-uppercase fs-8 ls-1">
            TRASLADOS Y SALIDAS
          </span>
        </div>
      </div>
      <!-- TRASLADOS -->
      <div class="menu-item">
        <router-link
          class="menu-link"
          active-class="active"
          to="/transfersDeparturesOrderList/traslados"
        >
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
              <i class="fas fa-bus"></i>
            </span>
          </span>
          <span class="menu-title">Traslados</span>
        </router-link>
      </div>

      <!-- LISTAS -->
      <div
        class="menu-item menu-accordion"
        data-kt-menu-sub="accordion"
        data-kt-menu-trigger="click"
      >
        <span class="menu-link">
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
              <i class="fas fa-sign-out"></i>
            </span>
          </span>
          <span class="menu-title">Salidas</span>
          <span class="menu-arrow"></span>
        </span>
        <div class="menu-sub menu-sub-accordion">
           <!-- LISTA detención domiciliaria -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/detencion_domiciliaria"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Detención domiciliaria</span>
            </router-link>
          </div>
          <!-- LISTA extramuro -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/extramuro"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Extramuro</span>
            </router-link>
          </div>
          <!-- LISTA libertad condicional -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/libertad_condicional"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Libertad condicional</span>
            </router-link>
          </div>
          <!-- LISTA libertad definitiva -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/salidas"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Libertad definitiva</span>
            </router-link>
          </div>
          <!-- LISTA libertad provisional -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/libertad_provisional"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Libertad provisional</span>
            </router-link>
          </div>
          <!-- LISTA perdón judicial -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/perdon_judicial"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Perdón judicial </span>
            </router-link>
          </div>
          <!-- LISTA salidas alternativas -->
          <!-- <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/salidas_alternativas"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Salidas alternativas </span>
            </router-link>
          </div> -->
          <!-- LISTA Suspensión condicional de la pena -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/suspension_condicional_pena"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title">Suspensión condicional de la pena </span>
            </router-link>
          </div>
           <!-- LISTA Suspensión condicional del proceso -->
          <div class="menu-item">
            <router-link
              class="menu-link"
              active-class="active"
              to="/transfersDeparturesOrderList/suspension_condicional_proceso"
            >
              <span class="menu-bullet">
                <span class="bullet bullet-dot"></span>
              </span>
              <span class="menu-title"
                >Suspensión condicional del proceso
              </span>
            </router-link>
          </div>
        </div>
      </div>
      <!-- FALLECIDOS -->
      <div class="menu-item">
        <router-link
          class="menu-link"
          active-class="active"
          to="/transfersDeparturesOrderList/fallecimiento"
        >
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
              <i class="fas fa-cross"></i>
            </span>
          </span>
          <span class="menu-title">Fallecidos</span>
        </router-link>
      </div>
      <!-- EVACIONES -->
      <div class="menu-item">
        <router-link
          class="menu-link"
          active-class="active"
          to="/transfersDeparturesOrderList/evasion"
        >
          <span class="menu-icon">
            <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
            <span
              v-else-if="asideMenuIcons === 'svg'"
              class="svg-icon svg-icon-2"
            >
              <i class="fas fa-running"></i>
            </span>
          </span>
          <span class="menu-title">Evaciones</span>
        </router-link>
      </div>
    </div>

      <!-- VISITAS -->
      <div v-if="rol === 'admin' || rol === 'editor'|| rol === 'visitas'" >
        <div class="menu-item">
          <div class="menu-content pt-8 pb-2">
            <span class="menu-section text-muted text-uppercase fs-8 ls-1">
              VISITAS A PRIVADOS DE LIBERTAD
            </span>
          </div>
        </div>
        <!-- VISITAS -->
        <div class="menu-item">
          <router-link class="menu-link" active-class="active" to="/visits">
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-id-card"></i>
              </span>
            </span>
            <span class="menu-title">Registro de Visitas</span>
          </router-link>
        </div>
        <!-- LISTA DE VISITAS -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/list_visits"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-list-alt"></i>
              </span>
            </span>
            <span class="menu-title">Lista de Visitas</span>
          </router-link>
        </div>
        <!-- registro de restricciones a visitas -->
        <div class="menu-item">
          <router-link class="menu-link" 
                       active-class="active" 
                      to="/restriction/0">
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-user-slash"></i>
              </span>
            </span>
            <span class="menu-title">Registro de Restricción</span>
          </router-link>
        </div>
        <!-- LISTA DE RESTRICCIONES -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/list_restrictions"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-table-list"></i>
              </span>
            </span>
            <span class="menu-title">Lista de Restricciones</span>
          </router-link>
        </div>
        <!-- <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/listPenitentiary"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-house"></i>
              </span>
            </span>
            <span class="menu-title">Centros Penitenciarios</span>
          </router-link>
        </div> -->
      </div>
      <!-- MÓDULOS INTERDISCIPLINARIOS -->
      <div v-if="rol === 'admin'" >
        <div class="menu-item">
          <div class="menu-content pt-8 pb-2">
            <span class="menu-section text-muted text-uppercase fs-8 ls-1">
              MÓDULOS INTERDISCIPLINARIOS
            </span>
          </div>
        </div>
        <!-- LEGAL -->
        <div class="menu-item">
          <router-link 
            class="menu-link" 
            active-class="active" 
            to="/dashboard_modules/legal">
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-gavel"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Legal</span>
          </router-link>
        </div>
        <!-- TRABAJO SOCIAL -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/dashboard_modules/social_worker"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-users"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Trabajo Social</span>
          </router-link>
        </div>
        <!-- PSICOLOGIA -->
        <div class="menu-item">
          <router-link 
            class="menu-link" 
            active-class="active" 
            to="/dashboard_modules/phychologic"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-brain"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Psicológico</span>
          </router-link>
        </div>
        <!-- EDUCACIÓN -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/dashboard_modules/education"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-user-graduate"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Educación</span>
          </router-link>
        </div>
        <!-- SALUD -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/dashboard_modules/medical"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-notes-medical"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Salud</span>
          </router-link>
        </div>
        <!-- ODONTOLOGÍA -->
        <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/dashboard_modules/dental"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-tooth"></i>
              </span>
            </span>
            <span class="menu-title">Módulo Odontológico</span>
          </router-link>
        </div>
        <!-- <div class="menu-item">
          <router-link
            class="menu-link"
            active-class="active"
            to="/listPenitentiary"
          >
            <span class="menu-icon">
              <i v-if="asideMenuIcons === 'font'" class="bi fs-3"></i>
              <span
                v-else-if="asideMenuIcons === 'svg'"
                class="svg-icon svg-icon-2"
              >
                <i class="fas fa-house"></i>
              </span>
            </span>
            <span class="menu-title">Centros Penitenciarios</span>
          </router-link>
        </div> -->
      </div>
      <!-- <template v-for="(item, i) in MainMenuConfig" :key="i">
        <div v-if="item.heading" class="menu-item">
          <div class="menu-content pt-8 pb-2">
            <span class="menu-section text-muted text-uppercase fs-8 ls-1">
              {{ translate(item.heading) }}
            </span>
          </div>
        </div>
        <template v-for="(menuItem, j) in item.pages" :key="j">
          <template v-if="menuItem.heading">
            <div class="menu-item">
              <router-link
                class="menu-link"
                active-class="active"
                :to="menuItem.route"
              >
                <span
                  v-if="menuItem.svgIcon || menuItem.fontIcon"
                  class="menu-icon"
                >
                  <i
                    v-if="asideMenuIcons === 'font'"
                    :class="menuItem.fontIcon"
                    class="bi fs-3"
                  ></i>
                  <span
                    v-else-if="asideMenuIcons === 'svg'"
                    class="svg-icon svg-icon-2"
                  >
                    <inline-svg :src="menuItem.svgIcon" />
                  </span>
                </span>
                <span class="menu-title">{{
                  translate(menuItem.heading)
                }}</span>
              </router-link>
            </div>
          </template>
          <div
            v-if="menuItem.sectionTitle"
            :class="{ show: hasActiveChildren(menuItem.route) }"
            class="menu-item menu-accordion"
            data-kt-menu-sub="accordion"
            data-kt-menu-trigger="click"
          >
            <span class="menu-link">
              <span
                v-if="menuItem.svgIcon || menuItem.fontIcon"
                class="menu-icon"
              >
                <i
                  v-if="asideMenuIcons === 'font'"
                  :class="menuItem.fontIcon"
                  class="bi fs-3"
                ></i>
                <span
                  v-else-if="asideMenuIcons === 'svg'"
                  class="svg-icon svg-icon-2"
                >
                  <inline-svg :src="menuItem.svgIcon" />
                </span>
              </span>
              <span class="menu-title">{{
                translate(menuItem.sectionTitle)
              }}</span>
              <span class="menu-arrow"></span>
            </span>
            <div
              :class="{ show: hasActiveChildren(menuItem.route) }"
              class="menu-sub menu-sub-accordion"
            >
              <template v-for="(item2, k) in menuItem.sub" :key="k">
                <div v-if="item2.heading" class="menu-item">
                  <router-link
                    class="menu-link"
                    active-class="active"
                    :to="item2.route"
                  >
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      translate(item2.heading)
                    }}</span>
                  </router-link>
                </div>
                <div
                  v-if="item2.sectionTitle"
                  :class="{ show: hasActiveChildren(item2.route) }"
                  class="menu-item menu-accordion"
                  data-kt-menu-sub="accordion"
                  data-kt-menu-trigger="click"
                >
                  <span class="menu-link">
                    <span class="menu-bullet">
                      <span class="bullet bullet-dot"></span>
                    </span>
                    <span class="menu-title">{{
                      translate(item2.sectionTitle)
                    }}</span>
                    <span class="menu-arrow"></span>
                  </span>
                  <div
                    :class="{ show: hasActiveChildren(item2.route) }"
                    class="menu-sub menu-sub-accordion"
                  >
                    <template v-for="(item3, k) in item2.sub" :key="k">
                      <div v-if="item3.heading" class="menu-item">
                        <router-link
                          class="menu-link"
                          active-class="active"
                          :to="item3.route"
                        >
                          <span class="menu-bullet">
                            <span class="bullet bullet-dot"></span>
                          </span>
                          <span class="menu-title">{{
                            translate(item3.heading)
                          }}</span>
                        </router-link>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </template> -->
      <div class="menu-item">
        <div class="menu-content">
          <div class="separator mx-1 my-4"></div>
        </div>
      </div>
    </div>
    <!--end::Menu-->
  </div>
  <!--end::Menu wrapper-->
  <!-- <modalSearchPpl ref="refSearchPpl"></modalSearchPpl> -->
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import useAuth from "@/auth/composables/useAuth";
import router from "@/auth/router";
import modalSearchPplVue from "@/views/modalSearchPpl.vue";

export default defineComponent({
  name: "menu_lateral",
  // components: {modalSearchPplVue},
  setup() {
    const dialog = ref(false);
    // const refSearchPpl = ref(null);
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref(null);
    let isAdmin = ref("");
    let isEditor = ref("");
    const { rol } = useAuth();
    const openModalSearch = () => {
      dialog.value = true;
      // refSearchPpl.value.showModal(dialog.value, 0);
    };
    onMounted(() => {
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        } else if (rol.toUpperCase() === "EDITOR") {
          isEditor.value = true;
        }
      }
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      translate,
      isAdmin,
      isEditor,
      rol,
      // refSearchPpl,
      dialog,
      openModalSearch
    };
  },
});
</script>
